export const clipboard = async (text) => {
  try {
    // Modern approach using Clipboard API
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }

    // Fallback for older browsers
    const textArea = document.createElement('textarea');
    textArea.value = text;

    // Preserve spaces and newlines
    textArea.style.cssText = `
              position: fixed;
              top: -9999px;
              left: -9999px;
              width: 2em;
              height: 2em;
              padding: 0;
              border: none;
              outline: none;
              box-shadow: none;
              background: transparent;
              white-space: pre;
          `;

    document.body.appendChild(textArea);

    // Handle iOS devices
    if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
      textArea.contentEditable = true;
      textArea.readOnly = false;

      const range = document.createRange();
      range.selectNodeContents(textArea);

      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      textArea.setSelectionRange(0, 999999);
    } else {
      textArea.select();
    }

    const successful = document.execCommand('copy');
    document.body.removeChild(textArea);
    return successful;
  } catch (err) {
    console.error('Failed to copy text: ', err);
    return false;
  }
};
